export default {
      id: "ic_back-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#ic_back",
      toString: function () {
        return this.url;
      }
    }